import { Grid, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import MenuItem from "../../features/Landing/components/MenuItem";
import useControlQuickMenu from "./useControlQuickMenu";
import useReactGASend from "../../hooks/useReactGASend";

const QuickMenu = ({ menuItems, needSelectBranch, openModal }) => {
  const { makeEventTrackFn } = useReactGASend();
  const { handleItemClick, swiperRef } = useControlQuickMenu({
    menuItems,
    needSelectBranch,
    openModal,
  });
  if (!menuItems?.length) return null;

  const sortedMenuItems = [...menuItems].sort((a, b) => a.order - b.order);
  const groupedMenuItems = sortedMenuItems.reduce((acc, item, index) => {
    const groupIndex = Math.floor(index / 6);
    if (!acc[groupIndex]) {
      acc[groupIndex] = [];
    }
    acc[groupIndex].push(item);
    return acc;
  }, []);

  const rowClass = menuItems.length <= 3 ? "" : "grid-rows-2";

  const trackLinkClick = (item) => {
    makeEventTrackFn({
      category: "event",
      action: item.label,
      body: {
        data_btn_nm: item.label,
        data_btn_url: item.value,
      },
    });
  };

  return (
    <Swiper
      slidesPerView={1}
      pagination={{ clickable: true }}
      modules={[Grid, Pagination]}
      style={{ paddingTop: "10px" }}
    >
      {groupedMenuItems.map((group, index) => (
        <SwiperSlide
          key={index}
          className={`!grid grid-cols-3 gap-1 mb-4 px-4 ${rowClass}`}
        >
          {group.map((item, subIndex) => (
            <MenuItem
              key={subIndex}
              item={item}
              onClick={() => {
                handleItemClick(item);
                trackLinkClick(item);
              }}
            />
          ))}
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default QuickMenu;
